import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded'
import ImageRoundedIcon from '@mui/icons-material/ImageRounded'
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded'
import GroupAddRoundedIcon from '@mui/icons-material/GroupAddRounded'
import AirportShuttleRoundedIcon from '@mui/icons-material/AirportShuttleRounded'
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded'
import EventRoundedIcon from '@mui/icons-material/EventRounded'
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded'

// Presentation for each Getting Started step. Completion detection lives
// server-side in routers/siteConfig/onboarding.js - keys must match
// ONBOARDING_STEP_KEYS there.
const stepCatalogue = {
  companyProfile: {
    title: 'Complete your company profile',
    description:
      'Add your address and reply-to email so documents, invoices and system emails carry the right details.',
    href: '/site-configuration/company-settings',
    action: 'Open Company Settings',
    icon: BusinessRoundedIcon,
  },
  companyLogo: {
    title: 'Upload your logo',
    description:
      'Your logo appears on quotes, engagement letters, patient records and the staff portal.',
    href: '/site-configuration/company-settings',
    action: 'Upload Logo',
    icon: ImageRoundedIcon,
  },
  baseLocations: {
    title: 'Set up your base locations',
    description:
      'Name your bases and add their addresses. Vehicles, equipment and staff are all organised by base.',
    href: '/base-locations',
    action: 'Manage Bases',
    icon: PlaceRoundedIcon,
  },
  teamMembers: {
    title: 'Invite your team',
    description:
      'Add your staff so they can log in, book shifts and complete records. You can import employees or add them one by one.',
    href: '/employees/new',
    action: 'Add an Employee',
    icon: GroupAddRoundedIcon,
  },
  vehicles: {
    title: 'Add your vehicles',
    description:
      'Register your fleet to unlock VDIs, cleaning schedules, make ready and defect reporting.',
    href: '/fleet',
    action: 'Open Fleet',
    icon: AirportShuttleRoundedIcon,
  },
  clients: {
    title: 'Add your first client',
    description:
      'Clients are the organisations you work for — used for quotes, events, invoicing and the client portal.',
    href: '/clients/new',
    action: 'Add a Client',
    icon: HandshakeRoundedIcon,
  },
  firstEvent: {
    title: 'Plan your first event or shift',
    description:
      'Create an event to plan cover, build medical plans and publish shifts for your team to book.',
    href: '/events/add-new',
    action: 'Create an Event',
    icon: EventRoundedIcon,
  },
  mandatoryTraining: {
    title: 'Configure mandatory training',
    description:
      'Set which courses each role needs and how often they renew, so compliance is tracked automatically.',
    href: '/site-configuration/mandatory-training',
    action: 'Set Up Training',
    icon: SchoolRoundedIcon,
  },
}

export default stepCatalogue
